// Section 24.7: actions check the season status machine and throw SimError('bad_status')
// otherwise; withBoundary turns that into an error card.
import { SimError, type GameState } from '../sim/api';
import { game, status, type SeasonStatus } from './state';

export function requireStatus(...allowed: SeasonStatus[]): void {
  if (!allowed.includes(status.value)) {
    throw new SimError(
      'bad_status',
      `action not allowed while ${status.value} (needs ${allowed.join(' or ')})`,
    );
  }
}

export function requireGame(): GameState {
  const g = game.value;
  if (g === null) throw new SimError('bad_status', 'no game in progress');
  return g;
}
